import React, { FunctionComponent } from 'react';

import clsx from 'clsx';

import styles from './Spinner.module.scss';

type ClassKey = 'root';
type Size = 'default' | 'xsmall' | 'large' | 'medium';
type SpinnerProps = {
    classes?: Classes<ClassKey>;
    size?: Size;
    isHidden?: boolean;
};

const sizeMap: Record<Size, number> = {
    xsmall: 8,
    medium: 18,
    default: 24,
    large: 40,
};

export const Spinner: FunctionComponent<SpinnerProps> = (props) => {
    const { classes, isHidden, size = 'default' } = props;

    const iconSize = sizeMap[size];

    return (
        <div className={clsx(styles.root, isHidden && styles.hidden, classes?.root)}>
            <svg
                width={iconSize}
                height={iconSize}
                className={styles.svg}
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle className={styles.circle} cx="50" cy="50" r="45" />
            </svg>
        </div>
    );
};
